import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    const excludeRoutes = [
      '/pdf-generation',
      '/payment-confirmation',
      '/create-new-password',
      '/verify-email',
      '/selectyourplan',
      '/verify-email-change',
      '/download-file',
      '/user/email-subscription'
    ];
    // Remove query params
    const path = url.split('?')[0].toLowerCase();
    const shouldExclude = excludeRoutes.some(route =>
      path.includes(route)
    );
    if (shouldExclude) {
      return super.parse(url); // DO NOT lowercase (token stays intact)
    }
    return super.parse(url.toLowerCase());
  }
}